import React from 'react';
import { motion } from 'framer-motion';
import { Star, Leaf } from 'lucide-react';
import { Button } from './Button';
export function Hero() {
  return <section className="relative bg-nutri-black text-white overflow-hidden pt-6 md:pt-10 pb-16 md:pb-20" data-id="element-99">
      {/* Decorative Leaves */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-100">
        {[...Array(6)].map((_, i) => <motion.div key={i} className="absolute text-nutri-dark opacity-20" initial={{
        y: Math.random() * 100,
        x: Math.random() * 100,
        rotate: 0
      }} animate={{
        y: [null, Math.random() * -50 - 20],
        x: [null, Math.random() * 50 - 25],
        rotate: [0, 360]
      }} transition={{
        duration: 15 + Math.random() * 10,
        repeat: Infinity,
        repeatType: 'reverse',
        ease: 'easeInOut'
      }} style={{
        top: `${Math.random() * 100}%`,
        left: `${Math.random() * 100}%`
      }} data-id="element-101">
            <Leaf size={40 + Math.random() * 60} data-id="element-102" />
          </motion.div>)}
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-103">
        <div className="flex flex-col items-center text-center max-w-4xl mx-auto" data-id="element-104">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="inline-block bg-nutri-medium/20 border border-nutri-medium text-nutri-mint px-4 py-1.5 rounded-full text-sm font-semibold mb-4" data-id="element-105">
            Para Nutricionistas y Licenciados en Nutrición
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight mb-6 uppercase" data-id="element-106">
            Tu consultorio nutricional{' '}
            <span className="relative inline-block text-nutri-cta drop-shadow-[0_0_25px_rgba(34,197,94,0.45)]" data-id="element-107">
              resuelto.
              <span className="absolute left-0 -bottom-1 md:-bottom-2 w-full h-1.5 md:h-2 bg-nutri-cta/50 rounded-full" data-id="element-108" />
            </span>
          </motion.h1>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.2,
          duration: 0.5
        }} className="w-full max-w-md lg:max-w-lg mb-6" data-id="element-109">
            <img src="https://cdn.magicpatterns.com/uploads/v5VCwuku6sFk4CQ88m8app/Untitled_design_(2).png" alt="NutriPro Kit Mockup - Libro 3D con planillas" className="w-full h-auto drop-shadow-2xl" data-id="element-110" />
          </motion.div>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3
        }} className="text-lg md:text-xl text-gray-300 mb-6 max-w-2xl" data-id="element-111">
            Más de 50 planillas editables listas para usar. Evaluá, documentá y
            seguí a tus pacientes de manera profesional en Excel y Google
            Sheets.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4
        }} className="flex flex-col items-center gap-4 w-full sm:w-auto" data-id="element-112">
            <Button className="text-lg md:text-xl px-10 py-5 w-full sm:w-auto" data-id="element-113">
              QUIERO EL NUTRIPRO KIT AHORA
            </Button>

            <div className="flex items-center gap-2 text-sm text-gray-400 mt-2" data-id="element-114">
              <div className="flex text-yellow-400" data-id="element-115">
                <Star size={16} fill="currentColor" data-id="element-116" />
                <Star size={16} fill="currentColor" data-id="element-117" />
                <Star size={16} fill="currentColor" data-id="element-118" />
                <Star size={16} fill="currentColor" data-id="element-119" />
                <Star size={16} fill="currentColor" data-id="element-120" />
              </div>
              <span data-id="element-121">
                4.9 ⭐ — +500 nutricionistas ya organizaron su consultorio
              </span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}